import {
  Alert,
  Box,
  Card,
  CardContent,
  Skeleton,
  Tooltip,
  Typography,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import styles from './HierarchyValueList.module.scss';
import useHierarchyRFMConfig from '../../hooks/useHierarchyRFMConfig';
import { isEmpty } from 'lodash';

type HierarchyValueListProps = {
  setEditing: (value: string) => void;
};

const HierarchyValueList = ({ setEditing }: HierarchyValueListProps) => {
  const {
    hierarchyValues,
    hierarchyValuesLoading,
    hierarchyValuesError,

    hierarchyRFMConfig,
    hierarchyRFMConfigError,

    selectedHierarchy,
  } = useHierarchyRFMConfig();

  if (hierarchyValuesLoading)
    return (
      <Box className={styles.container}>
        {Array.from({ length: 12 }).map((_, idx) => (
          <Skeleton
            key={idx}
            variant='rounded'
            height={40}
            className={styles.card}
          />
        ))}
      </Box>
    );
  if (isEmpty(selectedHierarchy)) return <></>;
  if (hierarchyValuesError && !hierarchyRFMConfigError)
    return <Alert severity='error'>{hierarchyValuesError}</Alert>;

  return (
    <Box className={styles.container}>
      {hierarchyValues.map((productHierarchy) => {
        const hierarchyValueLabel = productHierarchy[selectedHierarchy.key];
        const hasSegments = hierarchyRFMConfig?.value[hierarchyValueLabel];
        return (
          <Tooltip
            key={hierarchyValueLabel}
            title={hierarchyValueLabel}
            arrow
            placement='top'
          >
            <Card
              className={styles.card}
              onClick={() => setEditing(hierarchyValueLabel)}
            >
              <CardContent className={styles.cardContent}>
                <Typography
                  textAlign={'center'}
                  className={styles.ellipsisText}
                >
                  {hierarchyValueLabel}
                </Typography>
                {hasSegments && (
                  <CheckCircleIcon
                    color='success'
                    fontSize='small'
                  />
                )}
              </CardContent>
            </Card>
          </Tooltip>
        );
      })}
    </Box>
  );
};

export default HierarchyValueList;
